import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Chip } from '@mui/material';
import FilterBar from './FilterBar';

const statusStyle = (s) => {
  switch ((s || '').toUpperCase()) {
    case 'COMPLETE':  return { bgcolor: '#dcfce7', color: '#15803d' };
    case 'OPEN':      return { bgcolor: '#dbeafe', color: '#1d4ed8' };
    case 'REJECTED':  return { bgcolor: '#fee2e2', color: '#b91c1c' };
    case 'CANCELLED': return { bgcolor: '#f1f5f9', color: '#475569' };
    default:          return { bgcolor: '#fef3c7', color: '#b45309' };
  }
};

const OrderStatusTable = ({ orderStatus }) => {
  const [filters, setFilters] = useState([]);

  const filterOptions = {
    status:  [...new Set(orderStatus.map(s => s.status))].filter(Boolean),
    user_id: [...new Set(orderStatus.map(s => s.user_id))].filter(Boolean),
  };

  const columnLabels = {
    status:  'Status',
    user_id: 'User ID',
  };

  const addFilter    = (col, val) => setFilters(prev => [...prev.filter(f => f.column !== col), { column: col, value: val }]);
  const removeFilter = (col)      => setFilters(prev => prev.filter(f => f.column !== col));
  const clearFilters = ()         => setFilters([]);

  const filtered = orderStatus.filter(s =>
    filters.every(f => {
      if (f.column === 'status')  return s.status === f.value;
      if (f.column === 'user_id') return s.user_id === f.value;
      return true;
    })
  );

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <FilterBar
        filters={filters}
        filterOptions={filterOptions}
        columnLabels={columnLabels}
        onAdd={addFilter}
        onRemove={removeFilter}
        onClear={clearFilters}
      />
      <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell>User ID</TableCell>
              <TableCell>Symbol</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell>Rejection Reason</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Order ID</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.map((s, i) => (
              <TableRow key={i}>
                <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>{s.norentm}</TableCell>
                <TableCell sx={{ fontWeight: 500 }}>{s.user_id}</TableCell>
                <TableCell sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>{s.tsym}</TableCell>
                <TableCell align="right">{s.qty}</TableCell>
                <TableCell sx={{ color: s.rejreason && s.rejreason !== 'N/A' ? 'error.main' : 'text.secondary', fontSize: '0.775rem' }}>
                  {s.rejreason}
                </TableCell>
                <TableCell>
                  <Chip label={s.status} size="small" sx={{ ...statusStyle(s.status), fontWeight: 600, fontSize: '0.68rem', height: 20 }} />
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>{s.norenordno}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderStatusTable;
